import TrustpilotReviews from './TrustpilotReviews'

export default TrustpilotReviews
